import { createSelector } from 'reselect';
import { Selector } from '../../rootReducer';
import { IUploadedMediaItem, UploadStatus } from './types';

const getUploads: Selector<IUploadedMediaItem[]> = createSelector(
  [(state) => state.media.uploads],
  (uploads) =>
    uploads.map((item) => ({
      ...item,
      url: item.status === UploadStatus.OK ? item.url : '',
      selected: Boolean(item.selected),
    })),
);

export { getUploads };
